<template>
  <div class="settings_right">
    <template v-if="formloaded">
      <div class="form_section">
        <div class="form-container">
          <div class="vx-row">
            <template>
              <div class="vx-col w-full">
                <div class="form_group">
                  <label class="form_label">Account Domain<em>*</em>
                    <div class="IB_tooltip placement-down">
                      <span><info-icon size="1.5x" class="custom-class"></info-icon></span>
                      <div class="tooltip_cnt">
                        <p>
                          For example, if your company's name is XYZ Corporation,
                          your ImmiBox domain can be named to xyzcorp.immibox.com
                          as long as the domain isn't taken by another
                          organization.
                        </p>
                      </div>
                    </div>
                  </label>
                  <div class="sub_domain">
                    <vs-input :key="'subDomain'" type="text" :disabled="
                      checkProperty(tenantDetails, 'profCompleted') == 'Yes'
                    " oninput="this.value = this.value.replace(/[^a-z A-Z 0-9 .]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');"
                      v-model="updateTenantData.slug" class="w-full" name="subDomain" ref="subDomain" autocomplete="off"
                      autocorrect="off" autocapitalize="none" v-validate="'required|min:3|max:15'"
                      data-vv-as="Account Domain" />
                    <p>.immibox.com</p>
                    <span class="text-danger text-sm" v-if="errors.has('subDomain')">{{
                      errors.first("subDomain")
                    }}</span>
                  </div>
                </div>
              </div>
            </template>
          </div>

          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full" @click="
  documents = [];
logoUploading = false;
isLogoValid = true;
            ">
              <div class="form_group file_group">
                <label class="form_label">Logo <em>*</em>
                  <div class="IB_tooltip">
                    <span><info-icon size="1.5x" class="custom-class"></info-icon></span>
                    <div class="tooltip_cnt">
                      <p>
                        We recommend that you use a rectangular logo that is 240 X
                        36 pixels. The logo file must be less than 250 KB and in
                        JPG, PNG format.
                      </p>
                    </div>
                  </div>
                  <!----
this.isLogoValid =true;
this.isFaviconValid =true;
---->
                </label>
                <div class="vs-component">
                  <file-upload v-model="documents" class="file-upload-input" name="logo" data-vv-as="Logo"
                    :multiple="false" :accept="'.jpg,.jpeg,.png'" @input="upload(documents, 'logo')">
                    <img class="file-icon" src="@/assets/images/main/upload-big-arrow.svg" />
                    Upload Logo
                  </file-upload>
                  <span v-if="logoUploading" class="loader"><img src="@/assets/images/main/loader.gif" /></span>
                </div>
                <span v-if="updateTenantData.logo" class="imgPlaceholder">
                  <i @click="remove('logo')"></i>
                  <img class="file-icon upload-logo" :src="updateTenantData.logo" />
                </span>
                <span class="text-danger text-sm" v-if="!isLogoValid">*Logo is required</span>
              </div>
            </div>

            <div class="vx-col md:w-1/2 w-full" @click="
  documents = [];
faviconUploading = false;
isFaviconValid = true;
            ">
              <div class="form_group file_group">
                <label class="form_label">Favicon</label>
                <div class="vs-component">
                  <file-upload v-model="documents" class="file-upload-input" name="favicon" data-vv-as="Favicon"
                    :multiple="false" :accept="'.jpg,.jpeg,.png'" @input="upload(documents, 'favicon')">
                    <img class="file-icon" src="@/assets/images/main/upload-big-arrow.svg" />
                    Upload Favicon
                  </file-upload>
                  <span v-if="faviconUploading" class="loader"><img src="@/assets/images/main/loader.gif" /></span>
                </div>

                <span v-if="updateTenantData.favicon" class="imgPlaceholder">
                  <i @click="
  remove('favicon');
isFaviconValid = false;
                  "></i>
                  <img class="file-icon upload-favicon" :src="updateTenantData.favicon" />
                </span>

                <span class="text-danger text-sm" v-if="!isFaviconValid">Favicon is required</span>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">
              <div class="form_group">
                <label class="form_label">Admin Email</label>
                <vs-input :key="'adminEmail'" autocomplete="off" autocorrect="off" :disabled="true" name="adminEmail"
                  v-model="updateTenantData.adminEmail" class="w-full" data-vv-as="Admin Email" />
                <span class="text-danger text-sm" v-if="errors.has('adminEmail')">{{
                  errors.first("adminEmail")
                }}</span>
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div class="form_group">
                <label class="form_label">Name</label>
                <vs-input :key="'name'" autocomplete="off" autocorrect="off" name="name" v-model="updateTenantData.name"
                  class="w-full" data-vv-as="Name" />
                <span class="text-danger text-sm" v-if="errors.has('Name')">{{
                  errors.first("Name")
                }}</span>
              </div>
            </div>

            <div class="vx-col md:w-1/2 w-full">
              <div class="form_group">
                <label class="form_label">First Name<em>*</em></label>
                <vs-input :key="'adminFirstName'" autocomplete="off" autocorrect="off" v-validate="'required'" name="adminFirstName"
                  v-model="updateTenantData.adminFirstName" class="w-full" data-vv-as="First Name" />
                <span class="text-danger text-sm" v-if="errors.has('adminFirstName')">{{
                  errors.first("adminFirstName")
                }}</span>
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div class="form_group">
                <label class="form_label">Last Name<em>*</em></label>
                <vs-input :key="'adminLastName'" autocomplete="off" autocorrect="off" v-validate="'required'" name="adminLastName"
                  v-model="updateTenantData.adminLastName" class="w-full" data-vv-as="Last Name" />
                <span class="text-danger text-sm" v-if="errors.has('adminLastName')">{{
                  errors.first("adminLastName")
                }}</span>
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div class="form_group">
                <label class="form_label">Company Short Code<em>*</em>
                  <div class="IB_tooltip">
                    <span><info-icon size="1.5x" class="custom-class"></info-icon></span>
                    <div class="tooltip_cnt">
                      <p>
                        Company Short Code will be used as a prefix while creating
                        customers/invoices/cases.
                      </p>
                    </div>
                  </div>
                </label>
                <vs-input :key="'company_short_code'" type="text" :disabled="
                  checkProperty(tenantDetails, 'profCompleted') == 'Yes'
                " oninput="this.value = this.value.replace(/[^a-z A-Z 0-9]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');"
                  v-model="updateTenantData.idPrefix" class="w-full" name="company_short_code" ref="company_short_code"
                  autocomplete="off" autocorrect="off" autocapitalize="none" v-validate="'required|min:3|max:15'"
                  data-vv-as="Company Short Code" />
                <span class="text-danger text-sm" v-if="errors.has('company_short_code')">{{
                  errors.first("company_short_code")
                }}</span>
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div class="form_group">
                <label class="form_label">From Email
                  <!--<em>*</em>--></label>
                <vs-input :key="'fromEmail'" autocomplete="off" autocorrect="off" name="fromEmail" v-model="updateTenantData.fromEmail"
                  class="w-full" data-vv-as="From Email" v-validate="'email'" />
                <span class="text-danger text-sm" v-if="errors.has('fromEmail')">{{ errors.first("fromEmail") }}</span>
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div class="form_group">
                <label class="form_label">Contact Email<!--<em>*</em> --></label>
                <vs-input :key="'contactEmail'" autocomplete="off" autocorrect="off" name="contactEmail"
                  v-model="updateTenantData.contactEmail" class="w-full" data-vv-as="Contact Email"
                  v-validate="'email'" />
                <span class="text-danger text-sm" v-if="errors.has('contactEmail')">{{
                  errors.first("contactEmail")
                }}</span>
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div class="form_group ph_number">
                <div class="vs-component">
                  <label class="form_label">Phone Number<em>*</em></label>
                  <VuePhoneNumberInput autocomplete="off" autocorrect="off" icon-pack="feather"
                    class="w-full no-icon-border" :no-example="false" v-validate="'required'" name="phone"
                    data-vv-as="Phone Number" v-bind="vuePhone.props" :default-country-code="
                      checkProperty(
                        updateTenantData['phoneCountryCode'],
                        'countryCode'
                      )
                    " placeholder="Phone Number" :no-country-selector="false" v-model="updateTenantData.phone"
                    @update="updatePhone" :preferred-countries="['US', 'IN']"/>
                  <span class="text-danger text-sm" v-if="!isPhoneValid && !errors.has('phone')">*Invalid phone number -
                    Please enter a valid one</span>
                  <span class="text-danger text-sm" v-if="errors.has('phone')">{{
                    errors.first("phone")
                  }}</span>
                </div>
              </div>
            </div>
          </div>

          <template v-if="getTenantTypeId == 1">

            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full">
                <div class="form_group">
                  <label for="" class="form_label">Federal Employer Identification Number <div class="IB_tooltip">
                      <span><info-icon size="1.5x" class="custom-class"></info-icon></span>
                      <div class="tooltip_cnt">
                        <p>FEIN is Federal Employer Identification Number (EIN/FEIN) and a nine-digit number assigned by the IRS, normally available in the documents issued by IRS or in Tax Returns.</p>
                      </div>
                    </div></label>
                  <div class="vs-component">
                    <div class="vs-con-input">
                      <the-mask autocomplete="off" autocorrect="off" name="feiNumber"
                        v-model="updateTenantData.feiNumber" class="vs-inputx vs-input--input full"
                        data-vv-as="Federal Employer Identification Number" placeholder="##-#######"
                        :mask="['##-#######']" />
                    </div>
                    <!-- <span class="text-danger text-sm"
                    v-if="errors.has('feiNumber')">{{ errors.first("feiNumber") }}</span> -->
                  </div>
                </div>
              </div>
            </div>


            <!----
                if(this.getTenantTypeId==2) {
                  
                    if( !_.has(this.updateCompanyData['petitionerInfo'] ,'feinDocs')){
                    this.updateTenantData['petitionerInfo'] = Object.assign(this.updateTenantData['petitionerInfo'],{"feinDocs":[]})
                    }
                    this.updateTenantData['petitionerInfo']['feinDocs'].push(urlGenerated)
               
                  }
                
                ---->
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full" @click="value = []">
                <div class="form_group file_group">
                  <div class="vs-component marb10">
                    <label for="" class="form_label">FEIN Document or Latest Tax Return Document
                    </label>
                    <!-- @input="uploaddoc(value)" -->
                    <file-uploadd v-model="value" class="file-upload-input upload_file justify-center"
                      :accept="allDocEntity"  @updateData="updateData" :emitCategory="'feinDocs'" :fieldName="'feinDocs'"  :cid="'feinDocs'"
                      :name="'FEIN Documet'" :multiple="true" :hideSelected="true">
                      <img class="file-icon" src="@/assets/images/main/file-upload.svg" />
                      Upload
                    </file-uploadd>
                    <span v-if="uploading" class="loader"><img src="@/assets/images/main/loader.gif" /></span>
                  </div>
                  <span class="text-danger text-sm" v-if="errors.has('FEIN Documet')">{{
                    errors.first("FEIN Documet")
                  }}</span>


                  <ul class="uploaded-list">

                    <vs-chip @click="removedocs(index)" v-for="(item, index) in updateTenantData.feinDocs" :key="index"
                      closable> {{ item['name'] }} </vs-chip>
                  </ul>
                </div>
              </div>
            </div>
          </template>
          
          <h3 class="small-header">Address</h3>
          <addressFields :showaptType="true"
            :disableCountry="checkProperty(updateTenantData, 'address', 'countryId') > 0 ? true : false"
            :countries="countries" v-model="updateTenantData.address" :cid="'address'" />


          <h3 class="small-header">
            Mailing Address
          </h3>
          <div class="form_group flex_group" style="align-items:start">
            <!-- <label class="form_label">Same as above? </label> -->
            <!-- <div style="margin:-0px 0px 0px 5px">

              <vs-switch @input="addresssame()" v-model="updateTenantData.mailingAddressSame" v-if="false">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
              
            </div> -->
            <redioButtonsBoolean @input="addresssame()" :required="true"  :defaultError="true"
                  :wrapclass="'md:w-1/2 same_as_above'" :cid="'mailingAddressSame'"  :fieldName="'mailingAddressSame'"  
                  v-model="updateTenantData.mailingAddressSame"  label="Same as above?" placeHolder="" />


          </div>

          


          <template v-if="!updateTenantData.mailingAddressSame">
            <addressFields :showaptType="true" :disableCountry="true" :countries="countries"
              v-model="updateTenantData.mailingaddress" :cid="'mailingaddress'" />
          </template>

          <template v-if="getTenantTypeId == 2">


            <h3 class="small-header">Petitioner Details</h3>



            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full" v-if="getTenantTypeId !=2">
                <div class="form_group">
                  <label for="" class="form_label">IRS Trancation Id<em>*</em></label>
                  <vs-input :key="'irstaxId'" autocomplete="off" autocorrect="off" name="irstaxId"
                    v-model="updateTenantData.petitionerInfo.irstaxId" class="w-full"
                    oninput="this.value = this.value.replace(/[^a-z A-Z 0-9]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');"
                    data-vv-as="IRS Trancation Id" v-validate="'required|max:10'" />
                  <span class="text-danger text-sm" v-show="errors.has('irstaxId')">{{
                    errors.first("irstaxId")
                  }}</span>
                </div>



              </div>
              <div class="vx-col md:w-1/2 w-full">
                <div class="form_group">
                  <label for="" class="form_label">NAICS Code (as per Tax Return)<em>*</em>
                    <div class="IB_tooltip">
                      <span><info-icon size="1.5x" class="custom-class"></info-icon></span>
                      <div class="tooltip_cnt">
                        <p>The NAICS numbering system employs a five or six-digit code at the most detailed industry
                          level.</p>
                      </div>
                    </div>
                  </label>
                  <div class="vs-component">
                    <div class="vs-con-input">
                      <the-mask autocomplete="off" autocorrect="off" name="naicsCode"
                        v-model="updateTenantData.petitionerInfo.naicsCode" class="vs-inputx vs-input--input full"
                        data-vv-as="NAICS Code" v-validate="'required|min:2|max:6'" placeholder="######"
                        :mask="['######']" />
                    </div>
                    <span class="text-danger text-sm" v-if="errors.has('naicsCode')">{{
                      errors.first("naicsCode")
                    }}</span>
                  </div>
                </div>
              </div>

              <div class="vx-col md:w-1/2 w-full">
                <div class="form_group">
                  <label for="" class="form_label">Federal Employer Identification Number <div class="IB_tooltip">
                      <span><info-icon size="1.5x" class="custom-class"></info-icon></span>
                      <div class="tooltip_cnt">
                        <p>FEIN is Federal Employer Identification Number (EIN/FEIN) and a nine-digit number assigned by the IRS, normally available in the documents issued by IRS or in Tax Returns.</p>
                      </div>
                    </div></label>
                  <div class="vs-component">
                    <div class="vs-con-input">
                      <the-mask autocomplete="off" autocorrect="off" name="feiNumber"
                        v-model="updateTenantData.petitionerInfo.feiNumber" class="vs-inputx vs-input--input full"
                        data-vv-as="Federal Employer Identification Number" placeholder="##-#######"
                        :mask="['##-#######']" />
                    </div>
                    <!-- <span class="text-danger text-sm"
                    v-if="errors.has('feiNumber')">{{ errors.first("feiNumber") }}</span> -->
                  </div>
                </div>
              </div>

              <div class="vx-col md:w-1/2 w-full" @click="value = []">
                <div class="form_group file_group">
                  <div class="vs-component marb10">
                    <label for="" class="form_label">FEIN Document or Latest Tax Return Document
                    </label>
                    <!-- @input="uploaddoc(value)" -->
                    <file-uploadd v-model="value" class="file-upload-input upload_file justify-center"
                      :accept="allDocEntity" @updateData="updateData" :emitCategory="'petitionerInfo'" :fieldName="'petitionerInfo'"  :cid="'petitionerInfo'"
                      :name="'FEIN Documet'" :multiple="true" :hideSelected="true">
                      <img class="file-icon" src="@/assets/images/main/file-upload.svg" />
                      Upload
                    </file-uploadd>
                    <span v-if="uploading" class="loader"><img src="@/assets/images/main/loader.gif" /></span>
                  </div>
                  <span class="text-danger text-sm" v-if="errors.has('FEIN Documet')">{{
                    errors.first("FEIN Documet")
                  }}</span>


                  <ul class="uploaded-list"
                    v-if="checkProperty(updateTenantData['petitionerInfo'], 'feinDocs', 'length') > 0">
                    <vs-chip @click="removedocs(index)"
                      v-for="(item, index) in updateTenantData['petitionerInfo'].feinDocs" :key="index" closable> {{
                        item.name
                      }} </vs-chip>
                  </ul>
                </div>
              </div>
            </div>
            <h3 class="small-header"> Authorized Signatory </h3>

            <div class="vx-row">
              <div class="vx-col md:w-1/3 w-full">
                <div class="form_group">
                  <label for="" class="form_label">Position/Title<em>*</em></label>
                  <vs-input :key="'title'" placeholder="Director / Vice President / Partner" autocomplete="off" autocorrect="off"
                    name="title" v-model="updateTenantData.petitionerInfo.authorizedSignatory.title" class="w-full"
                    data-vv-as="Position/Title" v-validate="'required'" />
                  <span class="text-danger text-sm" v-if="errors.has('title')">{{ errors.first("title") }}</span>
                </div>
              </div>


              <div class="vx-col md:w-1/3 w-full">
                <div class="form_group">
                  <label for="" class="form_label">First Name<em>*</em></label>
                  <vs-input :key="'authorizedSignatoryFirstName'" autocomplete="off" autocorrect="off" name="authorizedSignatoryFirstName"
                    v-model="updateTenantData.petitionerInfo.authorizedSignatory.firstName" class="w-full"
                    data-vv-as="First Name" v-validate="'required'" />
                  <span class="text-danger text-sm" v-if="errors.has('authorizedSignatoryFirstName')">{{
                    errors.first("authorizedSignatoryFirstName")
                  }}</span>
                </div>
              </div>


              <div class="vx-col md:w-1/3 w-full">
                <div class="form_group">
                  <label for="" class="form_label">Last Name<em>*</em></label>
                  <vs-input :key="'authorizedSignatorylastName'" autocomplete="off" autocorrect="off" name="authorizedSignatorylastName"
                    v-model="updateTenantData.petitionerInfo.authorizedSignatory.lastName" class="w-full"
                    data-vv-as="Last Name" v-validate="'required'" />
                  <span class="text-danger text-sm" v-if="errors.has('authorizedSignatorylastName')">{{
                    errors.first("authorizedSignatorylastName")
                  }}</span>
                </div>
              </div>
              <div class="vx-col md:w-1/2 w-full">


                <div class="form_group">
                  <label for="" class="form_label">Email<em>*</em></label>
                  <vs-input :key="'authorizedSignatoryfromEmail'" autocomplete="off" autocorrect="off" name="authorizedSignatoryfromEmail"
                    v-model="updateTenantData.petitionerInfo.authorizedSignatory.email" class="w-full"
                    data-vv-as="Email" v-validate="'required|email'" />
                  <span class="text-danger text-sm" v-if="errors.has('authorizedSignatoryfromEmail')">{{
                    errors.first("authorizedSignatoryfromEmail")
                  }}</span>
                </div>
              </div>

              <div class="vx-col md:w-1/2 w-full">
                <div class="form_group ph_number">
                  <div class="vs-component">
                    <label for="" class="form_label">Phone Number<em>*</em></label>



                    <VuePhoneNumberInput autocomplete="off" autocorrect="off" icon-pack="feather"
                      class="w-full no-icon-border" :no-example="false" v-bind="vuePhone.props" v-validate="'required'"
                      name="authorizedSignatoryphone" data-vv-as="Phone Number"
                      :default-country-code="checkProperty(updateTenantData.petitionerInfo['authorizedSignatory']['phoneCountryCode'], 'countryCode')"
                      placeholder="Company Fax Number" :no-country-selector="false"
                      v-model="updateTenantData.petitionerInfo.authorizedSignatory.phone"
                      @update="updateAuthorizedSignatoryPhone" 
                      :preferred-countries="['US', 'IN']"/>
                    <span class="text-danger text-sm"
                      v-if="!isValidAuthorizedSignatoryPhone && !errors.has('authorizedSignatoryphone')">*Invalid phone
                      number - Please enter a valid one</span>

                    <span class="text-danger text-sm" v-if="errors.has('authorizedSignatoryphone')">{{
                      errors.first("authorizedSignatoryphone")
                    }}</span>
                  </div>
                </div>
              </div>



            </div>
            <!-----
          <h3 class="small-header">Address</h3>
          <addressFields
            :validationRequired="true"
            :showaptType="true"
            :disableCountry="false"
            :countries="countries"
            :address="updateTenantData.petitionerInfo.address"
            :cid="'petitionerInfo'"
          />
          -->
            <h3 class="small-header"> Business Information</h3>
            <div class="vx-row">

              <div class="vx-col md:w-1/2 w-full">
                <div class="form_group">
                  <label for="" class="form_label">Type of Business</label>
                  <vs-input :key="'typeOfBusiness'" autocomplete="off" autocorrect="off" name="typeOfBusiness"
                    v-model="updateTenantData.petitionerInfo.typeOfBusiness" class="w-full"
                    data-vv-as="Type of Business" v-validate="'max:150'" />
                  <span class="text-danger text-sm" v-if="errors.has('typeOfBusiness')">{{
                    errors.first("typeOfBusiness")
                  }}</span>
                </div>
              </div>

              <div class="vx-col w-full">
                <div class="form_group marb20">
                  <label for class="form_label">Briefly describe the nature of your business<em>*</em></label>


                  <!-- <vs-textarea
            v-model="updateTenantData.petitionerInfo.natureOfBusiness"
            name="natureOfBusiness"
            data-vv-as="Nature of business" 
            v-validate="'required'"
            class="w-full"
          /> -->

                  <ckeditor v-model="updateTenantData.petitionerInfo.natureOfBusiness" name="natureOfBusiness"
                    data-vv-as="Nature of business" v-validate="'required'" class="w-full" :editor="editor"
                    :config="editorConfig"></ckeditor>


                  <span class="text-danger text-sm" v-if="errors.has('natureOfBusiness')">{{
                    errors.first("natureOfBusiness")
                  }}</span>

                </div>
              </div>
              <!-- <div class="vx-col md:w-1/2 w-full" > 
              <div class="form_group">
                <div class="vs-component">
                  <label class="form_label">Date of business was established<em>*</em></label>
                  <datepicker  :typeable="true" name="businessEstdDate" 
                  :disabled-dates='disabledDates'
                  v-validate="'required'"
                  
                    data-vv-as="Date of business was established"
                    v-model="updateTenantData.petitionerInfo.businessEstdDate"  placeholder="MM/DD/YYYY">
                  </datepicker>
                <span class="text-danger text-sm"
                  v-if="errors.has('businessEstdDate')">{{ errors.first("businessEstdDate") }}</span>
              </div>
              </div>
            </div> -->
              <datepickerField wrapclass="md:w-1/2" :display="true" :dateEnableTo="disabledDates"
                v-model="updateTenantData.petitionerInfo.businessEstdDate" fieldName="businessEstdDate"
                label="Date of business was established" :validationRequired="true" />
              <div class="vx-col md:w-1/2 w-full">
                <div class="form_group">
                  <label class="form_label">Total number of full-time employees<em>*</em></label>
                  <vs-input :key="'totalFullTimeEmployees'" autocomplete="off" autocorrect="off" name="totalFullTimeEmployees"
                    v-model="updateTenantData.petitionerInfo.totalFullTimeEmployees" class="w-full"
                    data-vv-as="Total number of full-time employees" v-validate="'required'"
                    oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');" />
                  <span class="text-danger text-sm" v-if="errors.has('totalFullTimeEmployees')">{{
                    errors.first("totalFullTimeEmployees")
                  }}</span>
                </div>
              </div>

              <div class="vx-col md:w-1/2 w-full">
                <div class="form_group">
                  <label class="form_label">Estimated gross annual income<em>*</em></label>
                  <vs-input :key="'estimatedGrossAnualIncome'" autocomplete="off" autocorrect="off" name="estimatedGrossAnualIncome"
                    v-model="updateTenantData.petitionerInfo.estimatedGrossAnualIncome" class="w-full"
                    data-vv-as="Estimated gross annual income" v-validate="'required'" />
                  <span class="text-danger text-sm" v-if="errors.has('estimatedGrossAnualIncome')">{{
                    errors.first("estimatedGrossAnualIncome")
                  }}</span>
                </div>
              </div>

              <div class="vx-col md:w-1/2 w-full">
                <div class="form_group">
                  <label class="form_label">Estimated net annual income</label>
                  <vs-input :key="'estimatedNetAnualIncome'" autocomplete="off" autocorrect="off" name="estimatedNetAnualIncome"
                    v-model="updateTenantData.petitionerInfo.estimatedNetAnualIncome" class="w-full"
                    data-vv-as="Estimated net annual income" />
                  <span class="text-danger text-sm" v-if="errors.has('estimatedNetAnualIncome')">{{
                    errors.first("estimatedNetAnualIncome")
                  }}</span>
                </div>
              </div>

              <div class="vx-col w-full pt-2">

                <div class="table_switch switch_inlinlbl">
                  <vs-switch success v-model="updateTenantData.petitionerInfo.are50orMoreEmployeesInUS"
                    @change="are50orMoreEmployeesInUSChanged()" :name="'are50orMoreEmployeesInUS'">
                    <template #off>
                      <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 24 24"
                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" class="custom-class feather feather-x">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                      </svg>
                    </template>
                    <template #on>
                      <check-icon size="1.5x" class="custom-class"></check-icon>
                    </template>
                  </vs-switch>

                  Do you have 50 or more employees in USA?
                </div>




              </div>

              <div class="vx-col w-full pt-4" v-if="updateTenantData.petitionerInfo.are50orMoreEmployeesInUS">

                <div class="table_switch switch_inlinlbl">
                  <vs-switch success v-model="updateTenantData.petitionerInfo.areAbove50PercentH1BL1ALABStatus"
                    :name="'areAbove50PercentH1BL1ALABStatus'">
                    <template #off>
                      <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 24 24"
                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" class="custom-class feather feather-x">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                      </svg>
                    </template>
                    <template #on>
                      <check-icon size="1.5x" class="custom-class"></check-icon>
                    </template>
                  </vs-switch>

                  <!-- Are Above 50 Percent H1B L1 AL AB Status-->
                  Does 50% or more employees on H1/L1A/L1B Nonimmigrant status?
                </div>



                <!-- <span class="text-danger text-sm"  v-if="errors.has('areAbove50PercentH1BL1ALABStatus')">{{ errors.first("areAbove50PercentH1BL1ALABStatus") }}</span> -->

              </div>








            </div>

          </template>
          <template v-if="false">
          <h3 class="small-header">Biling Details</h3>
          <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full">
                      <div class="form_group">
                        <label class="form_label">Business Name<em>*</em></label>
                        <vs-input :key="'business name'" autocomplete="off" autocorrect="off" v-validate="'required'" name="business name"
                          v-model="updateTenantData.billingDetails.busName" class="w-full" data-vv-as="Business Name" />
                        <span class="text-danger text-sm" v-if="errors.has('business name')">{{
                          errors.first("business name")
                        }}</span>
                      </div>
                </div>
          </div>
          <h3 class="small-header">Authorized Person (Name)</h3>
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">
                      <div class="form_group">
                        <label class="form_label">Name<em>*</em></label>
                        <vs-input :key="'bilingName'" autocomplete="off" autocorrect="off" v-validate="'required'" name="bilingName"
                          v-model="updateTenantData.billingDetails.authPerson.name" class="w-full" data-vv-as="Name" />
                        <span class="text-danger text-sm" v-if="errors.has('bilingName')">{{
                          errors.first("bilingName")
                        }}</span>
                      </div>
                </div>
            <div class="vx-col md:w-1/2 w-full">
                      <div class="form_group">
                        <label class="form_label">Email<em>*</em></label>
                        <vs-input :key="'bilingEmail'" autocomplete="off" autocorrect="off" v-validate="'required'" name="bilingEmail"
                          v-model="updateTenantData.billingDetails.authPerson.email" class="w-full" data-vv-as="Email" />
                        <span class="text-danger text-sm" v-if="errors.has('bilingEmail')">{{
                          errors.first("bilingEmail")
                        }}</span>
                      </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <div class="form_group ph_number">
                    <div class="vs-component">
                      <label class="form_label">Phone Number<em>*</em></label>
                      <VuePhoneNumberInput autocomplete="off" autocorrect="off" icon-pack="feather"
                        class="w-full no-icon-border" :no-example="false" v-validate="'required'" name="billPhone"
                        data-vv-as="Phone Number" v-bind="vuePhone.props" :default-country-code="
                          checkProperty(updateTenantData.billingDetails['authPerson']['phoneCountryCode'], 'countryCode')
                        " placeholder="Phone Number" :no-country-selector="false" v-model="updateTenantData.billingDetails.authPerson.phone"
                        @update="updateAuthPersonPhone" :preferred-countries="['US', 'IN']"/>
                      <span class="text-danger text-sm" v-if="!isBillPhoneValid && !errors.has('billPhone')">*Invalid phone number -
                        Please enter a valid one</span>
                      <span class="text-danger text-sm" v-if="errors.has('billPhone')">{{
                        errors.first("billPhone")
                      }}</span>
                    </div>
                  </div>
                </div>
          </div>
          <h3 class="small-header">
            <div class="vx-row">
              <div class="vx-col">Address</div>
              <div class="vx-col w-50">

                <div class="form_group flex_group" style="align-items:start">
                  <vs-checkbox @input="isAddressSame" id="premium" name="premiumProcessing" v-model="updateTenantData.isSameasAdminInformation">Same as Admin Information?
                </vs-checkbox>
                </div>
              </div>
            </div>
          </h3>

          
          <!-- <template v-if="!updateTenantData.isSameasAdminInformation"> -->
            <addressFields :showaptType="true" :disableCountry="false" :countries="countries" :validationRequired="true"
              v-model="updateTenantData['billingDetails']['authPerson']['address']" :cid="'billingaddress'" />
          <!-- </template> -->

          <!-- <addressFields :showaptType="true"
            :disableCountry="false"
            :countries="countries" v-model="updateTenantData.address" :cid="'address'" /> -->
</template>
        </div>
        <div class="form-footer">
          <button v-if="updateTenantData.profComplted == 'Yes'" @click="
            completeTenantprofile = false;
            formSubmited = false;
            " class="cancel">
            Cancel
          </button>
          <!-- validateTenantData --->
          <button class="save" :disabled="formSubmited" @click="updateTenantProfile()">
            Update
          </button>
        </div>
      </div>

    </template>
    <template v-else>


      <NoDataFound ref="NoDataFoundRef" :loading="true" content="" :heading="''" type='Users' />

    </template>
  </div>
</template>

<script>
import FileUploadd from "@/views/FileUpload.vue";
import NoDataFound from "@/views/common/noData.vue";
import moment from "moment";
import Datepicker from "vuejs-datepicker-inv";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import FileUpload from "vue-upload-component/src";
import * as _ from "lodash";
import { InfoIcon } from "vue-feather-icons";

import { CheckIcon } from 'vue-feather-icons'
import JQuery from "jquery";
//import addressFields from "@/views/common/addressForm.vue";
import addressFields from "@/views/forms/fields/address.vue";
import datepickerField from "@/views/forms/fields/datepicker.vue";
import Vue from 'vue';
Vue.use(CKEditor);
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import redioButtonsBoolean from "@/views/forms/fields/redioButtonsBoolean.vue";

export default {
  provide() {
    return {
      parentValidator: this.$validator,
    };
  },
  name: "the-navbar",
  props: {
    navbarColor: {
      type: String,
      default: "#fff",
    },
  },
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        toolbar: ['bold', 'italic', '|', 'undo', 'redo', 'NumberedList', 'BulletedList',],
      },
      disabledDates: {
        from: new Date(),
      },
      isPhoneValid: true,
      isBillPhoneValid:true,
      formloaded: false,
      isLogoValid: true,
      isFaviconValid: true,
      uploading: false,
      value: [],
      faviconUploading: false,
      logoUploading: false,
      formSubmited: false,
      showIncompleteCheckListTxt: true,
      profileCompleted: false,
      isloading: false,
      documents: [],
      countries: [],
      states: [],
      locations: [],
      formerrors: {
        msg: "",
      },
      vuePhone: {
        props: {
          translations: {
            phoneNumberLabel: "Phone Number",
          },
        },
      },
      tenantDetails: {},
      isValidAuthorizedSignatoryPhone: true,
      updateTenantData: {
        // billingDetails:{
        //   busName:'',
        //   authPerson:{
        //     name:'',
        //     email:'',
        //     phone:'',
        //     phoneCountryCode:{
        //       countryCode:'IN',
        //       countryCallingCode:'91'
        //     },
        //     address: {
        //       line1: "",
        //       line2: "",
        //       countryId: '',
        //       countryDetails: null,
        //       stateId: "",
        //       locationId: "",
        //       zipcode: "",

        //       stateDetails: null,
        //       locationDetails: null,
        //       aptType: '',
        // },
            
        //   },

        // },

        isSameasAdminInformation:false,
        profComplted: "no",
        tenantId: "",
        name: "",
        adminEmail: "",
        adminFirstName: "",
        adminLastName: "",
        phone: "",
        phoneCountryCode: { countryCode: "", countryCallingCode: "" },
        logo: "",
        favicon: "",
        fromEmail: "",
        contactEmail: "",
        idPrefix: "",
        slug: "",
        assetPath: "",
        feiNumber: "",
        feinDocs: [],
        address: {
          line1: "",
          line2: "",
          countryId: 231,
          countryDetails: {
            _id: "61408c9ed01ea1248cdcf6b7",
            id: 231,
            name: "United States",
            phoneCode: 1,
            order: 1,
            currencySymbol: "$",
            currencyCode: "USD",
            zipcodeLength: 5,
            sortName: "united states",
          },
          stateId: "",
          locationId: "",
          zipcode: "",

          stateDetails: null,
          locationDetails: null,
          aptType: '',
        },
        mailingAddressSame: null,
        mailingaddress: {
          line1: "",
          line2: "",
          countryId: 231,
          countryDetails: {
            _id: "61408c9ed01ea1248cdcf6b7",
            id: 231,
            name: "United States",
            phoneCode: 1,
            order: 1,
            currencySymbol: "$",
            currencyCode: "USD",
            zipcodeLength: 5,
            sortName: "united states",
          },
          stateId: "",
          locationId: "",
          zipcode: "",

          stateDetails: null,
          locationDetails: null,
          aptType: '',

        },
        "petitionerInfo":
        {

          "irstaxId": "",
          "naicsCode": "",
          "feiNumber": "",
          "feinDocs": [],
          "address": {
            "line1": "",
            "line2": "",
            "aptType": "APT",
            "locationId": '',
            locationDetails: null,
            "stateId": '',
            stateDetails: null,
            "countryId": 231,
            countryDetails: {
              _id: "61408c9ed01ea1248cdcf6b7",
              id: 231,
              name: "United States",
              phoneCode: 1,
              order: 1,
              currencySymbol: "$",
              currencyCode: "USD",
              zipcodeLength: 5,
              sortName: "united states",
            },
            "zipcode": ""
          },
          "authorizedSignatory": {
            "firstName": "",
            "middleName": "",
            "lastName": "",
            "title": "",
            "email": "",
            "phone": "",
            "phoneCountryCode": {
              "countryCode": "IN",
              "countryCallingCode": "91"
            }
          },
          "typeOfBusiness": "",
          "natureOfBusiness": "",
          "businessEstdDate": "",
          "totalFullTimeEmployees": 0,
          are50orMoreEmployeesInUS: false,
          areAbove50PercentH1BL1ALABStatus: false,
          finalDeterminationFromDOL: false,
          "estimatedNetAnualIncome": "54353.55",
          "estimatedGrossAnualIncome": "2342.55"
        },
      },
      completeTenantprofile: false,

      autoApply: "",
      reminderCount: 0,
      disable_reminder_btn: false,
      delNotification: { notifyId: "", removeAll: false },
      deleteAllConform: false,
      notification_popuptitle: "Delete",
      companyDetails: null,
      updateCompanyData: {
        companyId: "",
        email: "",
        name: "",
        phone: "",
        phoneCountryCode: { countryCode: "", countryCallingCode: "" },
        fax: "",
        faxCountryCode: { countryCode: "", countryCallingCode: "" },
        irstaxId: "",
        naicsCode: "",
        address: {
          line1: "",
          line2: "",
          locationId: 0,
          stateId: 0,
          countryId: 231,
          countryDetails: {
            _id: "61408c9ed01ea1248cdcf6b7",
            id: 231,
            name: "United States",
            phoneCode: 1,
            order: 1,
            currencySymbol: "$",
            currencyCode: "USD",
            zipcodeLength: 5,
            sortName: "united states",
          },
          zipcode: "",
        },
        authorizedSignatory: {
          name: "",
          firstName: "",
          lastName: "",
          title: "",
          email: "",
          phone: "",
          phoneCountryCode: { countryCode: "", countryCallingCode: "" },
        },
        natureOfBusiness: "",
        businessEstdDate: "",
        totalFullTimeEmployees: "",
        are50orMoreEmployeesInUS: false,
        areAbove50PercentH1BL1ALABStatus: false,
        finalDeterminationFromDOL: false,
        estimatedNetAnualIncome: 2342.55,
        estimatedGrossAnualIncome: 2342.55,
        logo: "https://innvectra.rmtportal.com/logo.png",
        //"completeRegistration": true // it should be true only if it is petitioner
      },
    };
  },
  watch: {
    $route() {
      this.isTenantProfileCompleted;

      this.formSubmited = false;
    },
  },
  mounted() {
    this.masterData("countries");
    this.disabledDates = {
      from: new Date(),
      //to: c, // Disable all dates up to specific date

    },
      this.profileCompleted = this.$store.state.common.profileCompleted;
    this.tenantDetails = Object.assign(this.tenantDetails, {
      address: { countryId: 231 },
    });

    this.updateTenantData.address.countryDetails = {
      _id: "61408c9ed01ea1248cdcf6b7",
      id: 231,
      name: "United States",
      phoneCode: 1,
      order: 1,
      currencySymbol: "$",
      currencyCode: "USD",
      zipcodeLength: 5,
      sortName: "united states",
    };

    
    this.pageTitle = this.$route.meta.title;

    if (this.getUserRoleId == 3 && _.has(this.getUserData, "tenantDetails")) {
      this.getTenantDetails();
    }
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  },
  computed: {
    getActiveSettingTab() {
      try {
        return this.$store.getters["common/getActiveSettingTab"];
      } catch (er) {
        return "profile";
      }
    },
    isValidURL() {
      var res = this.updateTenantData.slug.match(
        /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
      );
      return res !== null;
    },
    isTenantProfileCompleted() {
      if (this.getUserRoleId == 3) {
        if (this.$store.getters["isTenantProfileCompleted"]) {
          this.$modal.hide("updateTenantProfile-modal");
        }
        return this.$store.getters["isTenantProfileCompleted"] ? false : true;
      } else {
        return false;
      }
    },

    validateTenantData() {
      /*
      updateTenantData:{
        "feiNumber":"",
      "tenantId": "",
      "name": "",
      "adminFirstName":"",
      "adminLastName":"",
      "phone": "",
      "phoneCountryCode": "",
      "logo": "",
     "favicon": "test/favicon.ico",
     "fromEmail": "contact-test@yopmail.com",
     "contactEmail": "info-test@yopmail.com",
     "idPrefix": "",
     "slug": "",
     "assetPath": "",
    "address": {
        "line1" : "",
        "line2" : "",
        "countryId" : '',
        "stateId" : '',
        "locationId" : '',
        "zipcode" : ""
    }
      }
      */
      if (
        !_.has(this.updateTenantData, "name") ||
        !this.updateTenantData.name.trim() ||
        !_.has(this.updateTenantData, "adminEmail") ||
        !this.updateTenantData.adminEmail.trim() ||
        !_.has(this.updateTenantData, "adminFirstName") ||
        !this.updateTenantData.adminFirstName.trim() ||
        !_.has(this.updateTenantData, "adminLastName") ||
        !this.updateTenantData.adminLastName.trim() ||
        !_.has(this.updateTenantData, "adminLastName") ||
        !this.updateTenantData.adminLastName.trim() ||
        !_.has(this.updateTenantData, "phone") ||
        !this.updateTenantData.phone ||
        !_.has(this.updateTenantData, "logo") ||
        !this.updateTenantData.logo.trim() ||
        !_.has(this.updateTenantData, "favicon") ||
        !this.updateTenantData.favicon.trim() ||
        !_.has(this.updateTenantData, "fromEmail") ||
        !this.updateTenantData.fromEmail.trim() ||
        !_.has(this.updateTenantData, "contactEmail") ||
        !this.updateTenantData.contactEmail.trim() ||
        !_.has(this.updateTenantData, "slug") ||
        !this.updateTenantData.slug.trim() ||
        !_.has(this.updateTenantData, "idPrefix") ||
        !this.updateTenantData.idPrefix.trim() ||
        !_.has(this.updateTenantData, "address") ||
        !this.updateTenantData.address ||
        !_.has(this.updateTenantData["address"], "line1") ||
        !this.updateTenantData["address"].line1 ||
        !_.has(this.updateTenantData["address"], "line2") ||
        !this.updateTenantData["address"].line2 ||
        !_.has(this.updateTenantData["address"], "countryId") ||
        !this.updateTenantData["address"].countryId ||
        !_.has(this.updateTenantData["address"], "stateId") ||
        !this.updateTenantData["address"].stateId ||
        !_.has(this.updateTenantData["address"], "locationId") ||
        !this.updateTenantData["address"].locationId ||
        !_.has(this.updateTenantData["address"], "zipcode") ||
        !this.updateTenantData["address"].zipcode ||
        !_.has(this.updateTenantData.feiNumber) ||
        !this.updateTenantData.feiNumber
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {

    updateData(docs, category){
      if (this.getTenantTypeId == 1) {
        if (!_.has(this.updateTenantData, 'feinDocs')) {
          this.updateTenantData = Object.assign(this.updateTenantData, { "feinDocs": [] })
        }
        this.updateTenantData['feinDocs'] = docs;
      }
      else if (this.getTenantTypeId == 2) {
        if (!_.has(this.updateTenantData['petitionerInfo'], 'feinDocs')) {
          this.updateTenantData['petitionerInfo'] = Object.assign(this.updateTenantData['petitionerInfo'], { "feinDocs": [] })
        }
        this.updateTenantData['petitionerInfo']['feinDocs'] = docs;
      }
    },

    are50orMoreEmployeesInUSChanged() {
      if (!this.updateTenantData['petitionerInfo'].are50orMoreEmployeesInUS) {
        this.updateTenantData['petitionerInfo'].areAbove50PercentH1BL1ALABStatus = false;
      }
    },
    updateAuthPersonPhone(item){
      this.isBillPhoneValid = true
      if(item.isValid){
        this.updateTenantData['billingDetails']['authPerson'].phoneCountryCode = {countryCode:item.countryCode, countryCallingCode: item.countryCallingCode}
        this.updateTenantData['billingDetails']['authPerson'].phone = item.nationalNumber
      }else{
        this.isBillPhoneValid = false
      }

    },
    updateAuthorizedSignatoryPhone(item) {
      if (item.isValid) {
        this.updateTenantData['petitionerInfo']['authorizedSignatory'].phoneCountryCode = { countryCode: item.countryCode, countryCallingCode: item.countryCallingCode };
        this.updateTenantData['petitionerInfo']['authorizedSignatory'].phone = item.nationalNumber;
      }
    },
    scrollWIndow() {
      const $ = JQuery;

      $("html, body").animate(
        {
          scrollTop: $(".text-danger").first().offset().top,
        },
        2000
      );

      //  const firstField = Object.keys(this.errors.collect())[0];
      // const ele = $('[name=' + firstField + ']').parents('.vx-col');
      //  $('html, body').animate({ scrollTop: ele.offset().top }, 2000);
    },
    activateSettingTab(tab = "profile") {
      this.$store.dispatch("common/activateSettingTab", tab);
    },
    getTenantDetails() {
      let postData = {
        tenantId: this.getUserData["tenantDetails"]["_id"],
      };
      this.$store
        .dispatch("get_tenant_details", postData)
        .then((response) => {
          this.tenantDetails = response;

          this.initTenantProfileData();
          this.isTenantProfileCompleted;
        })
        .catch((error) => {
          this.showToster({ message: error, isError: true });
        });
    },
    updatePhone(item) {
      this.isPhoneValid = true;
      if (item.isValid) {
        this.updateTenantData.phoneCountryCode = {
          countryCode: item.countryCode,
          countryCallingCode: item.countryCallingCode,
        };
        this.updateTenantData.phone = item.nationalNumber;
      } else {
        this.isPhoneValid = false;
      }
    },

    isAddressSame(){

      if(this.updateTenantData['isSameasAdminInformation']){
        this.updateTenantData['billingDetails']['authPerson']['address'] = _.cloneDeep(this.updateTenantData["address"])
        this.updateTenantData = _.cloneDeep(this.updateTenantData);
      }else{
        this.updateTenantData['billingDetails']['authPerson']['address'] = {
            line1: "",
            line2: "",
            countryId: 231,
            countryDetails: {
              _id: "61408c9ed01ea1248cdcf6b7",
              id: 231,
              name: "United States",
              phoneCode: 1,
              order: 1,
              currencySymbol: "$",
              currencyCode: "USD",
              zipcodeLength: 5,
              sortName: "united states",
            },
            stateId: "",
            locationId: "",
            zipcode: "",

            stateDetails: null,
            locationDetails: null,
            aptType: '',
          }
      }

    },

    addresssame() {
      this.updateTenantData["mailingaddress"] = _.cloneDeep(this.updateTenantData["address"]);
      this.updateTenantData = _.cloneDeep(this.updateTenantData);
      setTimeout(() => {
        if (!this.checkProperty(this.updateTenantData, 'mailingAddressSame')) {

          this.updateTenantData["mailingaddress"] = {
            line1: "",
            line2: "",
            countryId: 231,
            countryDetails: {
              _id: "61408c9ed01ea1248cdcf6b7",
              id: 231,
              name: "United States",
              phoneCode: 1,
              order: 1,
              currencySymbol: "$",
              currencyCode: "USD",
              zipcodeLength: 5,
              sortName: "united states",
            },
            stateId: "",
            locationId: "",
            zipcode: "",

            stateDetails: null,
            locationDetails: null,
            aptType: '',
          }

        }

      });

    },
    initTenantProfileData() {
      if (this.getUserRoleId == 3 && this.tenantDetails) {
        let tempupdateTenantData = this.updateTenantData;
        let tenantDetails = this.tenantDetails;

        let address = {
          line1: "",
          line2: "",
          countryId: 231,
          countryDetails: null,
          stateId: "",
          stateDetails: null,
          locationId: "",
          locationDetails: null,
          zipcode: "",
          aptType: '',
        };

        //	"name": "",
        // "adminEmail":'', updateTenantData['billingDetails']['authPerson']['address']

       if(_.has(this.tenantDetails, 'billingDetails') && false){
          if(_.has(this.tenantDetails['billingDetails'], 'busName') && tenantDetails.billingDetails.busName.trim()){
            tempupdateTenantData['billingDetails']['busName'] =  this.tenantDetails.billingDetails.busName.trim()
          }

            if(_.has(this.tenantDetails['billingDetails'], 'authPerson')){
              if(_.has(this.tenantDetails['billingDetails']['authPerson'],'name') && tenantDetails.billingDetails.authPerson.name.trim()){
                tempupdateTenantData['billingDetails']['authPerson']['name'] =  this.tenantDetails.billingDetails.authPerson.name.trim()
              }
              if(_.has(this.tenantDetails['billingDetails']['authPerson'],'email') && tenantDetails.billingDetails.authPerson.email.trim()){
                tempupdateTenantData['billingDetails']['authPerson']['email'] =  this.tenantDetails.billingDetails.authPerson.email.trim()
              }
              if(_.has(this.tenantDetails['billingDetails']['authPerson'],'phone') && tenantDetails.billingDetails.authPerson.phone.trim()){
                tempupdateTenantData['billingDetails']['authPerson']['phone'] =  this.tenantDetails.billingDetails.authPerson.phone.trim()
              }
              
              if(_.has(this.tenantDetails['billingDetails']['authPerson'], 'phoneCountryCode')){
                if(_.has(this.tenantDetails['billingDetails']['authPerson']['phoneCountryCode'], 'countryCode') &&  tenantDetails.billingDetails.authPerson.phoneCountryCode.countryCode.trim()){
                  tempupdateTenantData['billingDetails']['authPerson']['phoneCountryCode']['countryCode'] = this.tenantDetails.billingDetails.authPerson.phoneCountryCode.countryCode.trim()
                }
                if(_.has(this.tenantDetails['billingDetails']['authPerson']['phoneCountryCode'], 'countryCallingCode') &&  tenantDetails.billingDetails.authPerson.phoneCountryCode.countryCallingCode.trim()){
                  tempupdateTenantData['billingDetails']['authPerson']['phoneCountryCode']['countryCallingCode'] = this.tenantDetails.billingDetails.authPerson.phoneCountryCode.countryCallingCode.trim()
                }
              }
              if (_.has(this.tenantDetails['billingDetails']['authPerson'], "address")) {
                let dt = this.tenantDetails['billingDetails']['authPerson']['address']
                tempupdateTenantData['billingDetails']['authPerson']["address"] = _.cloneDeep(dt);
                // if (_.has(dt, "line1")) {
                //   tempupdateTenantData['billingDetails']['authPerson']["address"]["line1"] = dt["line1"];
                // }
                // if (_.has(dt, "line2")) {
                //   tempupdateTenantData['billingDetails']['authPerson']["address"]["line2"] = dt["line2"];
                // }
                // if (_.has(dt, "countryDetails")) {
                //   tempupdateTenantData['billingDetails']['authPerson']["address"]["countryDetails"] = dt["countryDetails"];
                // }
                // if (_.has(dt, "countryId")) {
                //   tempupdateTenantData['billingDetails']['authPerson']["address"]["countryId"] = dt["countryId"];
                // }
                // if (_.has(dt, "stateId")) {
                //   tempupdateTenantData['billingDetails']['authPerson']["address"]["stateId"] = dt["stateId"];
                // }
                // if (_.has(dt, "stateDetails")) {
                //   tempupdateTenantData['billingDetails']['authPerson']["address"]["stateDetails"] = dt["stateDetails"];
                // }
                // if (_.has(dt, "locationDetails")) {
                //   tempupdateTenantData['billingDetails']['authPerson']["address"]["locationDetails"] = dt["locationDetails"];
                // }
                // if (_.has(dt, "zipcode")) {
                //   tempupdateTenantData['billingDetails']['authPerson']["address"]["zipcode"] = dt["zipcode"];
                // }
                // if (_.has(dt, "locationId")) {
                //   tempupdateTenantData['billingDetails']['authPerson']["address"]["locationId"] = dt["locationId"];
                // }
                // if (_.has(dt, "aptType")) {
                //   tempupdateTenantData['billingDetails']['authPerson']["address"]["aptType"] = dt["aptType"];
                // }

              } else {
                // tempupdateTenantData["billingDetails"]['authPerson']['address'] = address;
              }
            }

       } 

        if (_.has(this.tenantDetails, "name") && tenantDetails.name.trim()) {
          tempupdateTenantData["name"] = this.tenantDetails.name.trim();
        }
        if (
          _.has(this.tenantDetails, "adminEmail") &&
          tenantDetails.adminEmail.trim()
        ) {
          tempupdateTenantData["adminEmail"] =
            this.tenantDetails.adminEmail.trim();
        }
        if (
          _.has(this.tenantDetails, "adminFirstName") &&
          tenantDetails.adminFirstName.trim()
        ) {
          tempupdateTenantData["adminFirstName"] =
            this.tenantDetails.adminFirstName.trim();
        }
        if (
          _.has(this.tenantDetails, "adminLastName") &&
          tenantDetails.adminLastName.trim()
        ) {
          tempupdateTenantData["adminLastName"] =
            this.tenantDetails.adminLastName.trim();
        }
        if (_.has(this.tenantDetails, "phone") && tenantDetails.phone) {
          tempupdateTenantData["phone"] = this.tenantDetails.phone;
        }
        if (
          _.has(this.tenantDetails, "phoneCountryCode") &&
          tenantDetails.phoneCountryCode
        ) {
          tempupdateTenantData["phoneCountryCode"] =
            this.tenantDetails.phoneCountryCode;
        }

        if (_.has(this.tenantDetails, "logo") && tenantDetails.phone) {
          tempupdateTenantData["logo"] = this.tenantDetails.logo;
        }
        if (_.has(this.tenantDetails, "favicon") && tenantDetails.favicon) {
          tempupdateTenantData["favicon"] = this.tenantDetails.favicon;
        }
        if (_.has(this.tenantDetails, "fromEmail") && tenantDetails.fromEmail) {
          tempupdateTenantData["fromEmail"] = this.tenantDetails.fromEmail;
        }
        if (
          _.has(this.tenantDetails, "contactEmail") &&
          tenantDetails.contactEmail
        ) {
          tempupdateTenantData["contactEmail"] =
            this.tenantDetails.contactEmail;
        }
        if (
          _.has(this.tenantDetails, "contactEmail") &&
          tenantDetails.contactEmail
        ) {
          tempupdateTenantData["contactEmail"] =
            this.tenantDetails.contactEmail;
        }
        if (_.has(this.tenantDetails, "slug") && tenantDetails.slug) {
          tempupdateTenantData["slug"] = this.tenantDetails.slug;
        }
        if (_.has(this.tenantDetails, "idPrefix") && tenantDetails.idPrefix) {
          tempupdateTenantData["idPrefix"] = this.tenantDetails.idPrefix;
        }
        if (_.has(this.tenantDetails, "idPrefix") && tenantDetails.idPrefix) {
          tempupdateTenantData["idPrefix"] = this.tenantDetails.idPrefix;
        }
        if (_.has(this.tenantDetails, "feiNumber") && tenantDetails.feiNumber) {
          tempupdateTenantData["feiNumber"] = this.tenantDetails.feiNumber;
        }
        if (_.has(this.tenantDetails, "feinDocs") && tenantDetails.feinDocs) {
          tempupdateTenantData["feinDocs"] = this.tenantDetails.feinDocs;
          this.value = this.tenantDetails.feinDocs
        }

        if (_.has(this.tenantDetails, "address")) {
          tempupdateTenantData["address"] = address;
          if (_.has(this.tenantDetails["address"], "line1")) {
            tempupdateTenantData["address"]["line1"] =
              tenantDetails["address"]["line1"];
          }
          if (_.has(this.tenantDetails["address"], "line2")) {
            tempupdateTenantData["address"]["line2"] =
              tenantDetails["address"]["line2"];
          }
          // if (_.has(this.tenantDetails["address"], "countryId")) {
          // {{updateTenantData.address.countryDetails}}
          this.tenantDetails["address"]["countryId"] = 231;
          this.updateTenantData.address.countryDetails = {
            _id: "61408c9ed01ea1248cdcf6b7",
            id: 231,
            name: "United States",
            phoneCode: 1,
            order: 1,
            currencySymbol: "$",
            currencyCode: "USD",
            zipcodeLength: 5,
            sortName: "united states",
          };
          tempupdateTenantData["address"]["countryId"] = 231; //tenantDetails["address"]["countryId"];
          if (this.countries.length >= 0) {
            tempupdateTenantData["address"]["countryDetails"] = _.find(
              this.countries,
              { id: tempupdateTenantData["address"]["countryId"] }
            );
            this.formloaded = true;
            this.changedCountry();
          }
          // }
          if (_.has(this.tenantDetails["address"], "stateId")) {
            tempupdateTenantData["address"]["stateId"] =
              tenantDetails["address"]["stateId"];
          }
          if (_.has(this.tenantDetails["address"], "locationId")) {
            tempupdateTenantData["address"]["locationId"] =
              tenantDetails["address"]["locationId"];
          }
          if (_.has(this.tenantDetails["address"], "zipcode")) {
            tempupdateTenantData["address"]["zipcode"] =
              tenantDetails["address"]["zipcode"];
          }
          _.forEach(this.tenantDetails["address"], (val, key) => {
            tempupdateTenantData["address"][key] = val;

          })
        } else {
          tempupdateTenantData["address"] = address;
        }





        tempupdateTenantData["mailingaddress"] = this.tenantDetails["mailingaddress"];


        if (_.has(this.tenantDetails, "_id") && tenantDetails._id) {
          tempupdateTenantData["tenantId"] = this.tenantDetails._id;
        }

        tempupdateTenantData = Object.assign(tempupdateTenantData, {
          profComplted: "no",
        });
        if (_.has(this.tenantDetails, "profComplted")) {
          tempupdateTenantData["profComplted"] = tenantDetails["profComplted"];
        }


        if (this.getTenantTypeId == 2) {
          if (_.has(this.tenantDetails, 'petitionerInfo')) {


            tempupdateTenantData['petitionerInfo'] = _.cloneDeep(this.tenantDetails['petitionerInfo']);
            tempupdateTenantData = _.cloneDeep(tempupdateTenantData)
            let companyData = _.cloneDeep(this.tenantDetails['petitionerInfo']);
            let address = { line1: "", line2: "", countryId: 231, "countryDetails": null, stateId: '', "stateDetails": null, locationId: '', "locationDetails": null, zipcode: '', 'aptType': '' };

            _.forEach(companyData, (value, key) => {

              // alert("key=="+key +"   VALUE=="+value);
              if (key == 'address') {

                if (!_.has(companyData['address'], 'aptType')) {
                  companyData['address']['aptType'] = "APT"
                }
                _.forEach(companyData['address'], (adval, adkey) => {

                  address[adkey] = _.cloneDeep(adval);

                })

                if (!_.has(address, 'aptType')) {
                  address = Object.assign(address, { 'aptType': 'APT' })
                }


                tempupdateTenantData['petitionerInfo']['address'] = _.cloneDeep(address);
                tempupdateTenantData = _.cloneDeep(tempupdateTenantData);

                if (this.countries.length >= 0 && this.checkProperty(tempupdateTenantData['petitionerInfo'], 'address', 'countryId')) {
                  tempupdateTenantData['petitionerInfo']['address']['countryDetails'] = _.find(this.countries, { "id": tempupdateTenantData['petitionerInfo']['address']['countryId'] });
                  tempupdateTenantData['petitionerInfo']['address']['countryDetails'] = _.find(this.countries, { "id": tempupdateTenantData['petitionerInfo']['address']['countryId'] });
                  tempupdateTenantData = _.cloneDeep(tempupdateTenantData);

                  // this.changedCountry();
                }



              } else if (key == 'authorizedSignatory') {



                _.forEach(companyData['authorizedSignatory'], (authval, authkey) => {

                  if (_.has(tempupdateTenantData['petitionerInfo']['authorizedSignatory'], authkey)) {
                    tempupdateTenantData['petitionerInfo']['authorizedSignatory'][authkey] = _.cloneDeep(authval);

                  }

                })


              } else if (key == "are50orMoreEmployeesInUS") {
                if (value.toLowerCase() == "yes") {
                  tempupdateTenantData['petitionerInfo']['are50orMoreEmployeesInUS'] = true;
                } else {
                  tempupdateTenantData['petitionerInfo']['are50orMoreEmployeesInUS'] = false;
                }

              } else if (key == "finalDeterminationFromDOL") {
                if (value.toLowerCase() == "yes") {
                  tempupdateTenantData['petitionerInfo']['finalDeterminationFromDOL'] = true;
                } else {
                  tempupdateTenantData['petitionerInfo']['finalDeterminationFromDOL'] = false;
                }

              } else if (key == "areAbove50PercentH1BL1ALABStatus") {
                if (value.toLowerCase() == "yes") {
                  tempupdateTenantData['petitionerInfo']['areAbove50PercentH1BL1ALABStatus'] = true;
                } else {
                  tempupdateTenantData['petitionerInfo']['areAbove50PercentH1BL1ALABStatus'] = false;
                }

              }


            })



            if (!(_.has(this.tenantDetails['petitionerInfo'], 'address'))) {

              address['countryId'] = 231
              tempupdateTenantData['petitionerInfo']['address'] = _.cloneDeep(address);
              tempupdateTenantData = _.cloneDeep(tempupdateTenantData)

              if (this.countries.length >= 0 && this.checkProperty(tempupdateTenantData['petitionerInfo'], 'address', 'countryId')) {
                tempupdateTenantData['petitionerInfo']['address']['countryDetails'] = _.find(this.countries, { "id": tempupdateTenantData['petitionerInfo']['address']['countryId'] });
                tempupdateTenantData['petitionerInfo']['address']['countryDetails'] = _.find(this.countries, { "id": tempupdateTenantData['petitionerInfo']['address']['countryId'] });
                tempupdateTenantData = _.cloneDeep(tempupdateTenantData);


              }
              tempupdateTenantData = _.cloneDeep(tempupdateTenantData)
            }

          } else {

            tempupdateTenantData['petitionerInfo'] = {

              "irstaxId": "",
              "naicsCode": "",
              "feiNumber": "",
              "feinDocs": [],
              "address": {
                "line1": "",
                "line2": "",
                "aptType": "APT",
                "locationId": '',
                locationDetails: null,
                "stateId": '',
                stateDetails: null,
                "countryId": 231,
                countryDetails: null,
                "zipcode": ""
              },
              "authorizedSignatory": {
                "firstName": "",
                "middleName": "",
                "lastName": "",
                "title": "",
                "email": "",
                "phone": "",
                "phoneCountryCode": {
                  "countryCode": "IN",
                  "countryCallingCode": "91"
                }
              },
              "typeOfBusiness": "",
              "natureOfBusiness": "",
              "businessEstdDate": "",
              "totalFullTimeEmployees": 0,
              are50orMoreEmployeesInUS: false,
              areAbove50PercentH1BL1ALABStatus: false,
              finalDeterminationFromDOL: false,
              "estimatedNetAnualIncome": "54353.55",
              "estimatedGrossAnualIncome": "2342.55"
            }

            tempupdateTenantData = _.cloneDeep(tempupdateTenantData);

          }
        }




        this.updateTenantData.mailingAddressSame = tenantDetails["mailingAddressSame"];
        if (!_.has(tempupdateTenantData["mailingaddress"], 'aptType')) {
          tempupdateTenantData["mailingaddress"]['aptType'] = '';
        }
        if (!_.has(tempupdateTenantData["address"], 'aptType')) {
          tempupdateTenantData["address"]['aptType'] = '';
        }
        this.updateTenantData = tempupdateTenantData;



        if (!_.has(this.tenantDetails, "profComplted") || !tenantDetails.profComplted.trim() || tenantDetails.profComplted.toLowerCase() != "yes") {
          this.completeTenantprofile = true;
        }
      }
      this.formloaded = false;
      this.$validator.reset();
      setTimeout(() => {

        this.$validator.reset();
        this.formloaded = true;
        setTimeout(() => {
          this.$validator.reset();
          this.formloaded = true;

        })
      })

    },
    updateTenantProfile() {
      //alert(JSON.stringify(this.updateTenantData))
      this.$validator.validateAll().then((result) => {
        this.isLogoValid = true;
        this.isFaviconValid = true;
        if (
          !_.has(this.updateTenantData, "logo") ||
          !this.updateTenantData.logo.trim()
        ) {
          this.isLogoValid = false;
        }
        /*
if(( !(_.has(this.updateTenantData ,'favicon')) || !this.updateTenantData.favicon.trim())){
  this.isFaviconValid =false;
}
*/

        if (result && this.isLogoValid) {
          let postData = _.cloneDeep(this.updateTenantData);

          if (this.updateTenantData.profComplted != "Yes") {
            // this.updateTenantData.profComplted ="Yes";
            postData = Object.assign(postData, {
              assetPath: postData["slug"].trim(),
              profComplted: "Yes",
              profCompleted: "Yes",
            });
          }
          this.formSubmited = true;
          //alert();
          //return false;
          if (_.has(postData, 'petitionerInfo')) {
            if (_.has(postData, "petitionerInfo.are50orMoreEmployeesInUS")) {
              if (this.checkProperty(postData, 'petitionerInfo', 'are50orMoreEmployeesInUS')) {
                postData['petitionerInfo']['are50orMoreEmployeesInUS'] = 'yes';
              } else {
                postData['petitionerInfo']['are50orMoreEmployeesInUS'] = 'no';
              }

            }

            if (_.has(postData, "petitionerInfo.finalDeterminationFromDOL")) {
              if (this.checkProperty(postData, 'petitionerInfo', 'finalDeterminationFromDOL')) {
                postData['petitionerInfo']['finalDeterminationFromDOL'] = 'yes';
              } else {
                postData['petitionerInfo']['finalDeterminationFromDOL'] = 'no';
              }

            }

            if (_.has(postData, "petitionerInfo.areAbove50PercentH1BL1ALABStatus")) {
              if (this.checkProperty(postData, 'petitionerInfo', 'areAbove50PercentH1BL1ALABStatus')) {
                postData['petitionerInfo']['areAbove50PercentH1BL1ALABStatus'] = 'yes';
              } else {
                postData['petitionerInfo']['areAbove50PercentH1BL1ALABStatus'] = 'no';
              }

            }

          }




          this.$vs.loading();
          this.$store
            .dispatch("updateTenantProfile", postData)
            .then((response) => {


              //v-model="updateTenantData.adminLastName"   v-model="updateTenantData.adminFirstName" updateTenantData.name
              let profileData = { 'email': '', "name": "", 'firstName': '', 'lastName': '' };

              profileData['email'] = this.updateTenantData['adminEmail'];
              profileData['firstName'] = this.updateTenantData['adminFirstName'];
              profileData['lastName'] = this.updateTenantData['adminLastName'];
              profileData['name'] = this.updateTenantData['adminFirstName'] + " " + this.updateTenantData['adminLastName'];

              this.$store.commit("updateProfileData", profileData);
              
              localStorage.setItem('tenantProfilecompleted', 'true');
              this.$store.commit('updatedNewLogo', { "url": null, 'type': 'favicon' });
              this.$store.commit('updatedNewLogo', { "url": null, 'type': 'logo' });
              this.showToster({ message: response.message, isError: false });
              this.completeTenantprofile = false;
              this.getTenantDetails();
              this.isTenantProfileCompleted;
              this.formSubmited = false;
              var self = this;

              this.$emit("activateSettingTab", "usersRoles");
              /*
              if(!this.profileCompleted){
                   setTimeout(function(){
                self.$router.push('/branch-list')
              },600)

              }
              */
              this.$vs.loading.close();
            })
            .catch((error) => {
              this.$store.commit('updatedNewLogo', { "url": null, 'type': favicon, 'type': logo });
              this.$vs.loading.close();
              this.formSubmited = false;
              this.showToster({ message: error, isError: true });
            });
        } else {
          this.$vs.loading.close();
          this.scrollWIndow();
        }
      });
    },
    uploaddoc(docs, type = "tenant") {
      this.loading = false;
      let value = _.cloneDeep(docs);
      this.value = [];
      value = docs.map(item => item = {
        name: item.name,
        file: item.file,
        url: "",
        mimetype: item.type,
        status: item.status === null || item.status === undefined ? true : item.status
      })
      let tempFiles = [];
      
      if (value.length > 0) {
        let count = 0;

        this.uploading = true;

        //this.uploading =true;
        value.forEach(doc => {
          let formData = new FormData();
          formData.append('files', doc.file);
          formData.append('secureType', 'private');
          formData.append("getDetails", true);
          this.$store.dispatch('uploadS3File', formData).then(response => {
            count = count + 1;
            response.data.result.forEach(urlGenerated => {
              if (this.getTenantTypeId == 1) {


                if (!_.has(this.updateTenantData, 'feinDocs')) {
                  this.updateTenantData = Object.assign(this.updateTenantData, { "feinDocs": [] })
                }

                this.updateTenantData['feinDocs'].push(urlGenerated);


              }
              else if (this.getTenantTypeId == 2) {

                if (!_.has(this.updateTenantData['petitionerInfo'], 'feinDocs')) {
                  this.updateTenantData['petitionerInfo'] = Object.assign(this.updateTenantData['petitionerInfo'], { "feinDocs": [] })
                }
                this.updateTenantData['petitionerInfo']['feinDocs'].push(urlGenerated)

              }



            })

            delete doc.file;
           
            if (count >= value.length) {
              this.uploading = false;

            }
            //this.value = [];  
          })
        })
        //value.splice(0, value.length, ...value);
      }

    },
    removedocs(filindex) {


      if (this.getTenantTypeId == 1) {
        let item=this.updateTenantData['feinDocs'][filindex]
        this.updateTenantData['feinDocs'].splice(filindex, 1);
        this.removeFileFromS3(item)
      }
      else if (this.getTenantTypeId == 2) {
        let item=this.updateTenantData['petitionerInfo'].feinDocs[filindex]
        this.updateTenantData['petitionerInfo'].feinDocs.splice(filindex, 1);
        this.removeFileFromS3(item)
      }
    },
    upload(files, type = "logo") {
      this.faviconUploading = false;
      this.logoUploading = false;
      let model = _.cloneDeep(files);
      let acceptTypesFiles = 'image/png,image/jpeg,image/jpg,.jpg,.jpeg,.png'
      this.documents = [];
      this.loading = true;
      let formData = new FormData();
      let temp_count = 0;
      let mapper = model.map(
        (item) =>
        (item = {
          name: item.name,
          file: item.file ? item.file : null,
          path: item.url ? item.url : "",
          url: item.url ? item.url : "",
          extn: item.name.split(".").pop(),
          mimetype: item.type ? item.type : item.mimetype,
        })
      );

      if (mapper.length > 0) {
        if (type == "logo") {
          this.logoUploading = true;
        } else {
          this.faviconUploading = true;
        }
        
        mapper.forEach((doc, index) => {
          if(_.has(doc, 'mimetype') && acceptTypesFiles.includes(doc['mimetype']) ){
            this.isloading = true;
            formData.append("files", doc.file); 
            formData.append("secureType", "public");
            this.$store.dispatch("uploadS3File", formData).then((response) => {
              temp_count++;
              // alert(type) updateCompanyData
              response.data.result.forEach((urlGenerated) => {
                if (this.getUserRoleId == 12) {
                  if (type == "logo") {
                    this.updateCompanyData = Object.assign(
                      this.updateCompanyData,
                      { logo: urlGenerated }
                    );

                  } else {
                    // alert(type+" ----- ")
                    this.updateCompanyData = Object.assign(
                      this.updateCompanyData,
                      { favicon: urlGenerated }
                    );
                  }
                }
                else {
                  this.$store.commit('updatedNewLogo', { "url": urlGenerated, 'type': type });
                  if (type == "logo") {
                    this.updateTenantData = Object.assign(this.updateTenantData, {
                      logo: urlGenerated,
                    });
                  } else {
                    // alert(type+" ----- ")
                    this.updateTenantData = Object.assign(this.updateTenantData, {
                      favicon: urlGenerated,
                    });
                    this.setFavIcon(true)
                  }
                }
                this.faviconUploading = false;
                this.logoUploading = false;

                if (temp_count >= mapper.length) {
                  this.documents = [];
                }
                doc.url = urlGenerated;
                delete doc.file;
                mapper[index] = doc;
              });

              this.faviconUploading = false;
              this.logoUploading = false;
            });
          }else{
            this.faviconUploading = false;
            this.logoUploading = false;
            this.showToster({ message: 'Select image only', isError: true });
          }
        });
        model.splice(0, mapper.length, ...mapper);
      }
    },
    remove(item) {
      if (this.getUserRoleId == 12) {
        this.updateCompanyData[item] = "";
      } else {
        if (item == 'logo') {
          this.$store.commit('updatedNewLogo', { "url": null, 'type': 'logo' });
        }
        else {
          this.$store.commit('updatedNewLogo', { "url": null, 'type': 'favicon' });
          this.setFavIcon(false)
        }
        this.updateTenantData[item] = "";
      }
    },
    changedCountry() {
      this.states = [];
      this.locations = [];
      let dataKey = "updateTenantData";
      if (this.getUserRoleId == 12) {
        dataKey = "updateCompanyData";
      }
      if (_.has(this[dataKey].address.countryDetails, "id")) {
        this[dataKey].address.countryId =
          this[dataKey].address.countryDetails["id"];

        this.masterData("states");
      }
    },
    changedState() {
      let dataKey = "updateTenantData";
      if (this.getUserRoleId == 12) {
        dataKey = "updateCompanyData";
      }

      this.locations = [];
      if (_.has(this[dataKey].address.stateDetails, "id")) {
        this[dataKey].address.stateId =
          this[dataKey].address.stateDetails["id"];
        this.masterData("locations");
      }
    },
    //locationId
    changedCity() {
      let dataKey = "updateTenantData";
      if (this.getUserRoleId == 12) {
        dataKey = "updateCompanyData";
      }

      if (_.has(this[dataKey].address.locationDetails, "id")) {
        this[dataKey].address.locationId =
          this[dataKey].address.locationDetails["id"];
        //this.masterData("locations");
      }
    },
    masterData(category = "countries") {
      let matcher = {};
      let postData = {
        matcher: matcher,
        page: 1,
        perpage: 1000,
        category: category,
      };

      let dataKey = "updateTenantData";
      let detailsDataKey = "tenantDetails";

      if (this.getUserRoleId == 12) {
        dataKey = "updateCompanyData";
        detailsDataKey = "companyDetails";
      }

      if (category == "states") {
        matcher = { countryId: this[dataKey].address.countryDetails["id"] };
      }
      if (category == "locations") {
        matcher = { stateId: this[dataKey].address.stateDetails["id"] };
      }
      postData["matcher"] = matcher;

      this.$store
        .dispatch("getMasterData", postData)
        .then((res) => {
          //countries

          if (category == "countries") {
            this.countries = res["list"];

            this.updateTenantData.address.countryDetails = {
              _id: "61408c9ed01ea1248cdcf6b7",
              id: 231,
              name: "United States",
              phoneCode: 1,
              order: 1,
              currencySymbol: "$",
              currencyCode: "USD",
              zipcodeLength: 5,
              sortName: "united states",
            };
            this.changedCountry();
            //alert(JSON.stringify(this.countries))
          } else if (category == "states") {
            this.states = res["list"];
            if (
              this[detailsDataKey] &&
              _.has(this[detailsDataKey]["address"], "stateId")
            ) {
              this[dataKey]["address"].stateDetails = _.find(this.states, {
                id: this[detailsDataKey]["address"]["stateId"],
              });
              this.changedState();
            }
          } else if (category == "locations") {
            this.locations = res["list"];
            if (
              this[detailsDataKey] &&
              _.has(this[detailsDataKey]["address"], "locationId")
            ) {
              this[dataKey]["address"].locationDetails = _.find(this.locations, {
                id: this[detailsDataKey]["address"]["locationId"],
              });
            }
          }
        })
        .catch((err) => {
          
          this[category] = [];
        });
    },
    selected(item) {
      this.$router.push(item.url);
      this.showFullSearch = false;
    },
  },
  directives: {},
  components: {
    FileUploadd,
    redioButtonsBoolean,
    datepickerField,
    NoDataFound,
    VuePhoneNumberInput,
    FileUpload,
    addressFields,
    moment,
    Datepicker,
    InfoIcon,
    CheckIcon
  },
};
</script>